import {
    AVG_MEDIA_LENGTH_LABEL,
    STORAGE_AWS_DEEP_GLACIER_LABEL,
    STORAGE_AWS_GLACIER_LABEL,
    STORAGE_HIGH_DENSITY_LABEL,
    STORAGE_HIGH_VELOCITY_LABEL
} from '../strings/labels'

const mboxTitle = 'Number of files per month'

export default {
    mbox: {
        low: {
            title: mboxTitle,
            max: 10000,
            step: 100
        },
        standard: {
            title: mboxTitle,
            max: 10000,
            step: 100
        },
        high: {
            title: mboxTitle,
            max: 10000,
            step: 100
        },
        custom: {
            title: mboxTitle,
            max: 10000,
            step: 100
        }
    },
    storage: {
        highVelocity: {
            title: STORAGE_HIGH_VELOCITY_LABEL,
            max: 100,
            step: 10
        },
        highDensity: {
            title: STORAGE_HIGH_DENSITY_LABEL,
            max: 500,
            step: 10
        },
        awsGlacier: {
            title: STORAGE_AWS_GLACIER_LABEL,
            max: 9999,
            step: 50
        },
        awsDeepGlacier: {
            title: STORAGE_AWS_DEEP_GLACIER_LABEL,
            max: 9999,
            step: 50
        }
    },
    averageMediaLength: {
        title: AVG_MEDIA_LENGTH_LABEL,
        max: 180
    },
    quicklink: {
        views: {
            title: 'Number of views',
            step: 100,
            max: 10000
        },
        downloads: {
            title: 'Number of downloads',
            step: 100,
            max: 10000
        }
    },
    numberOfFiles: {
        title: 'Number of files per month',
        step: 100,
        max: 10000
    },
    s3Downloads: {
        title: 'S3 Downloads',
        step: 100,
        max: 1000
    },
    profiles: {
        title: 'Number of profiles',
        tooltip: 'How many resolutions are needed for this group of uploads',
        min: 1,
        max: 9
    },
    restore: {
        title: 'Restore from AWS (GB)',
        tooltip:
            'How many GB of media is going to be restored from AWS Glacier every month',
        step: 10,
        max: 10000
    },
    migration: {
        title: 'Size in GB',
        step: 1,
        max: 10000
    },
    proxyRegeneration: {
        title: 'Size in GB',
        tooltip: '',
        step: 1,
        max: 10000
    }
}
